"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeliveryByOrderNumberApi = exports.getAllDeliveriesApi = void 0;
const apiPath_1 = require("../apiPath");
// Get all deliveries
const getAllDeliveriesApi = async (axiosInstance) => {
    try {
        const data = await axiosInstance.get(apiPath_1.API_PATH.delivery.getAll.frontend);
        return data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getAllDeliveriesApi = getAllDeliveriesApi;
const getDeliveryByOrderNumberApi = async (axiosInstance, orderNumber) => {
    try {
        const data = await axiosInstance.get(apiPath_1.API_PATH.delivery.getByOrderNumber.frontend(orderNumber));
        return data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getDeliveryByOrderNumberApi = getDeliveryByOrderNumberApi;
// // Get delivery by ID
// export const getDeliveryByIdApi = async (
//   axiosInstance: AxiosInstance,
//   id: string
// ): Promise<Delivery> => {
//   try {
//     const data = await axiosInstance.get<Delivery>(
//       API_PATH.delivery.getById.frontend( id)
//     );
//     return data.data;
//   } catch (error: any) {
//     throw error.response?.data || error.message;
//   }
// };
// // Get deliveries by client ID
// export const getDeliveriesByClientIdApi = async (
//   axiosInstance: AxiosInstance,
//   clientId: string
// ): Promise<Delivery[]> => {
//   try {
//     const data = await axiosInstance.get<Delivery[]>(
//       API_PATH.delivery.getByClientId.frontend(clientId)
//     );
//     return data.data;
//   } catch (error: any) {
//     throw error.response?.data || error.message;
//   }
// };
// // Get delivery by order ID
// export const getDeliveryByOrderIdApi = async (
//   axiosInstance: AxiosInstance,
//   orderId: string
// ): Promise<Delivery> => {
//   try {
//     const data = await axiosInstance.get<Delivery>(
//       API_PATH.delivery.getByOrderId.frontend.replace(':orderId', orderId)
//     );
//     return data.data;
//   } catch (error: any) {
//     throw error.response?.data || error.message;
//   }
// };
// // Create a new delivery
// export const createDeliveryApi = async (
//   axiosInstance: AxiosInstance,
//   params: CreateDeliveryParams
// ): Promise<Delivery> => {
//   try {
//     const data = await axiosInstance.post<Delivery>(
//       API_PATH.delivery.create.frontend,
//       params
//     );
//     return data.data;
//   } catch (error: any) {
//     throw error.response?.data || error.message;
//   }
// };
// // Update delivery status
// export const updateDeliveryStatusApi = async (
//   axiosInstance: AxiosInstance,
//   id: string,
//   status: DeliveryStatus
// ): Promise<Delivery> => {
//   try {
//     const data = await axiosInstance.put<Delivery>(
//       API_PATH.delivery.updateStatus.frontend.replace(':id', id),
//       { status }
//     );
//     return data.data;
//   } catch (error: any) {
//     throw error.response?.data || error.message;
//   }
// };
// // Assign delivery person
// export const assignDeliveryPersonApi = async (
//   axiosInstance: AxiosInstance,
//   id: string,
//   deliveryPersonId: string
// ): Promise<Delivery> => {
//   try {
//     const data = await axiosInstance.put<Delivery>(
//       API_PATH.delivery.assign.frontend.replace(':id', id),
//       { deliveryPersonId }
//     );
//     return data.data;
//   } catch (error: any) {
//     throw error.response?.data || error.message;
//   }
// };
//# sourceMappingURL=delivery.js.map